/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'

import Logo from '../../assets/images/Loader.gif'
import '../page-overlay/pageoverlay.css'
import './success-message.css'


// eslint-disable-next-line react/prop-types
const SuccessMessage = ({ submissionType, successType }) => {
  return (
    <div className='successMsg' id='successMsg'>
      {submissionType} {successType} Successfully.
    </div>
  )
}
export default SuccessMessage
